export const BorderLeftSubTitle = [
  {
    text: "Use the class of",
    code: ".b-l-* ",
  },
  {
    text: "for left border.",
  },
];

export const BorderRightSubTitle = [
  {
    text: "Use the class of",
    code: ".b-r-* ",
  },
  {
    text: "for right border.",
  },
];

export const BorderTopSubTitle = [
  {
    text: "Use the class of",
    code: ".b-t-* ",
  },
  {
    text: "for top border.",
  },
];

export const BorderBottomSubTitle = [
  {
    text: "Use the class of",
    code: ".b-b-* ",
  },
  {
    text: "for bottom border.",
  },
];

export const BorderPrimarySubTitle = [
  {
    text: "Use the class of",
    code: ".b-l-* ",
  },
  {
    text: "for left border and ",
    code: ".border-3 ",
  },
  {
    text: "is used to increase the width of the border.",
  },
];

export const BorderPrimaryData = [
  {
    id: 1,
    image: "1.jpg",
    name: "Teresa J. Mosteller",
  },
  {
    id: 2,
    image: "3.png",
    name: "Gloria D. Acheson",
  },
  {
    id: 3,
    image: "5.jpg",
    name: "Bryan A. Owens",
  },
];

export const BorderWarningData = [
  {
    id: 1,
    color: "primary",
    text: "known for delivery of useful and usable solutions",
  },
  {
    id: 2,
    color: "danger",
    text: "Solve your problem with us",
  },
  {
    id: 3,
    color: "success",
    text: "Certified Professionals",
  },
  {
    id: 4,
    color: "warning",
    text: "Growth-Driven",
  },
];

export const BorderSecondaryData = [
  {
    text: "Stella Nowland",
    class: "warning",
    text2: "Freelance",
  },
  {
    text: "Lola Stanford",
    class: "danger text-white",
    text2: "Issue",
  },
  {
    text: "Caitlin Coungeau",
    class: "primary text-white",
    text2: "Social",
  },
  {
    text: "Graciela McClaran",
    class: "danger text-white",
    text2: "Issue",
  },
];
